import React, { useState, useEffect } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToPrev = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-32 bg-[#000000] relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-400/5 rounded-full blur-[150px]" />
      </div>

      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-gold-400 text-xs font-medium tracking-[0.3em] uppercase mb-6 block">
            Utisci klijenata
          </span>
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-light text-gold-400 mb-6">
            Šta kažu <span className="text-gold-gradient">naši klijenti</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold-400 mx-auto" />
        </div>

        {/* Testimonial Card */}
        <div className="relative">
          {/* Large Quote Mark */}
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 text-gold-400/10 text-[200px] font-serif leading-none select-none">
            “
          </div>

          <div className="glass border border-gold-400/10 p-12 sm:p-16 relative">
            {/* Stars */}
            <div className="flex justify-center gap-2 mb-10">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-gold-400 fill-gold-400" />
              ))}
            </div>

            {/* Text */}
            <p className="text-white/80 text-xl sm:text-2xl text-center leading-relaxed font-light italic mb-12">
              "{testimonials[currentIndex].text}"
            </p>

            {/* Divider */}
            <div className="w-16 h-[1px] bg-gold-400/30 mx-auto mb-8" />

            {/* Author */}
            <div className="text-center">
              <p className="text-white font-medium tracking-wider text-lg">{testimonials[currentIndex].name}</p>
              <p className="text-gold-400 text-sm tracking-[0.2em] uppercase mt-2">{testimonials[currentIndex].event}</p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-12">
            <button
              onClick={goToPrev}
              className="w-12 h-12 border border-gold-400/30 flex items-center justify-center hover:border-gold-400 hover:bg-gold-400/10 transition-all duration-300"
            >
              <ChevronLeft className="w-5 h-5 text-gold-400" />
            </button>

            {/* Dots */}
            <div className="flex gap-3">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setIsAutoPlaying(false);
                    setCurrentIndex(index);
                  }}
                  className={`h-[2px] transition-all duration-300 ${
                    index === currentIndex
                      ? 'w-8 bg-gold-400'
                      : 'w-4 bg-white/20 hover:bg-white/40'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={goToNext}
              className="w-12 h-12 border border-gold-400/30 flex items-center justify-center hover:border-gold-400 hover:bg-gold-400/10 transition-all duration-300"
            >
              <ChevronRight className="w-5 h-5 text-gold-400" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
